import gsap from "gsap";
// import { startScroll, stopScroll } from "../utils";

const onloadAnimations = () => {
  const main = document.querySelector("main");
  const header = document.querySelector("header");
  const footer = document.querySelector("footer");
  const aside = document.querySelector("aside");

  const preloader = () => {
    gsap
      .timeline()
      .from([header, aside], { duration: 1, autoAlpha: 0, stagger: 0.3 });
  };

  preloader();
};

export { onloadAnimations };
